import { CSSProperties } from 'react';

const CIRCLE_SIZE = 24;

export default {
    container: {
        position: 'relative',
        marginTop: 20,
        marginBottom: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    barContainer: {
        width: '100%',
        height: 5,
        backgroundColor: '#ddd'
    },
    barFill: {
        height: 5,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    iconCircleContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    iconCircle: {
        width: CIRCLE_SIZE,
        height: CIRCLE_SIZE,
        borderRadius: CIRCLE_SIZE / 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    carIcon: {
        zIndex: 10,
        height: 48,
        marginTop: 1.5,
        transform: 'rotate(90deg) translateY(-60%)'
    }
} as Record<string, CSSProperties>;
